var React = require('react');

function DropdownArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.249744234","strokeLinecap":"square"},React.createElement("g",{"transform":"translate(-1286.000000, -704.000000)","stroke":"#041E42","strokeWidth":"2"},React.createElement("polyline",{"transform":"translate(1293.500000, 709.000000) rotate(-360.000000) translate(-1293.500000, -709.000000) ","points":"1288 706 1293.5 712 1299 706"}))));
}

DropdownArrow.defaultProps = {"width":"15px","height":"10px","viewBox":"0 0 15 10","version":"1.1"};

module.exports = DropdownArrow;

DropdownArrow.default = DropdownArrow;
